// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__AdCvD","alignRightCell":"styles_alignRightCell__aeRlo","row":"styles_row__MYdXa","titleWrap":"styles_titleWrap__yEmf1","wrapRight":"styles_wrapRight__PH-+b"};